import { Rating } from '@mui/material'
import { FiberManualRecord } from '@mui/icons-material'
import React, { memo } from 'react'

// TODO: probably need to be saved on the connectionScore field on profile as factors grow?
// Profiles can have any number of celebration / significant dates as of now which affects max score of the connection. This takes the score of 3 celebration scores currently
const MAX_SCORE = 2020
const MAX_DOTS = 5
const FULL_SCORE_RATIO = 0.6
const POINTS_PER_DOT = (MAX_SCORE * FULL_SCORE_RATIO) / MAX_DOTS

type ConnectionScoreProps = {
  current?: number
}

const ConnectionScore = ({ current = 0 }: ConnectionScoreProps) => {
  // TODO: needs to be adjusted if props change. Might not need if values are passed directly on a scale of 5
  const value = Math.min(MAX_DOTS, current / POINTS_PER_DOT)

  return (
    <Rating
      value={value}
      max={MAX_DOTS}
      precision={0.5}
      readOnly
      icon={<FiberManualRecord sx={{ color: 'primary.main' }} fontSize="inherit" />}
      emptyIcon={<FiberManualRecord sx={{ color: 'grey.300' }} fontSize="inherit" />}
      size="small"
    />
  )
}

export default memo(ConnectionScore)
